/** 物料库：listMaterials() 动态生成，可点击添加或拖到画布。 */
import { Empty } from 'antd';
import { listMaterials } from '@h5/materials';
import { CANVAS_HEIGHT, CANVAS_WIDTH, type MaterialDefinition } from '@h5/schema';
import { useEditorStore } from '../store/store';
import { MATERIAL_DND_TYPE } from '../canvas/Canvas';

const CATEGORY_LABEL: Record<MaterialDefinition['category'], string> = { basic: '基础', media: '媒体', interactive: '互动' };

function Icon({ icon }: { icon: MaterialDefinition['icon'] }) {
  if (typeof icon === 'string') return <span style={{ fontSize: 20 }}>{icon}</span>;
  const C = icon;
  return <C />;
}

export function MaterialsTab() {
  const addLayer = useEditorStore((s) => s.addLayer);
  const materials = listMaterials();
  if (materials.length === 0) return <Empty description="暂无物料（materials 包尚未注册）" style={{ marginTop: 40 }} />;

  const byCat = new Map<string, MaterialDefinition[]>();
  for (const m of materials) {
    if (!byCat.has(m.category)) byCat.set(m.category, []);
    byCat.get(m.category)!.push(m);
  }

  const add = (def: MaterialDefinition) => {
    addLayer(def.id, {
      name: def.name,
      materialVersion: def.version,
      rect: { x: Math.round((CANVAS_WIDTH - def.defaultSize.w) / 2), y: Math.round((CANVAS_HEIGHT - def.defaultSize.h) / 2), w: def.defaultSize.w, h: def.defaultSize.h, rotate: 0 },
      props: { ...def.defaultProps },
    });
  };

  return (
    <div style={{ padding: 8 }}>
      {[...byCat.entries()].map(([cat, list]) => (
        <div key={cat} style={{ marginBottom: 12 }}>
          <div style={{ fontSize: 12, color: '#888', margin: '4px 4px 8px' }}>{CATEGORY_LABEL[cat as MaterialDefinition['category']] ?? cat}</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 8 }}>
            {list.map((def) => (
              <div
                key={def.id}
                draggable
                onDragStart={(e) => { e.dataTransfer.setData(MATERIAL_DND_TYPE, def.id); e.dataTransfer.effectAllowed = 'copy'; }}
                onClick={() => add(def)}
                title={`点击或拖到画布添加「${def.name}」`}
                style={{ border: '1px solid #f0f0f0', borderRadius: 6, padding: '10px 4px', textAlign: 'center', cursor: 'grab', background: '#fff', fontSize: 12, userSelect: 'none' }}
              >
                <div style={{ height: 24, display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Icon icon={def.icon} /></div>
                <div style={{ marginTop: 4 }}>{def.name}</div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
